import admin from './view';

export default [
  {
    path: '/',
    redirect: 'company',
  },
  {
    path: 'company', // 등록업체목록
    component: admin('/user/companyList'),
  },
  {
    path: 'company/:companyNo', // 등록업체 상세
    component: admin('/user/companyDetail'),
  },
  {
    path: 'authorityUser/', // 기관회원 관리
    component: admin('/user/authorityUser'),
  },
  {
    path: 'authorityUser/register', // 기관-회원등록
    component: admin('/user/authorityUserJoin'),
  },
  {
    path: 'authorityUser/:id', // 기관회원 관리 - 상세보기
    component: admin('/user/authorityUserDetail'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/user.js